module.exports = __webpack_public_path__ + "static/media/watch-calculator.e730e7c4.svg";